import type { Point } from '../common/dimensions';

export enum MarkerType {
	NONE,
	BASE,
	BASE_OFFSET,
}

export interface MarkerInsightState {
	applied: boolean;
	detection_id: string;
	detection_class: string;
	// detections from before masks were added will not have a version number
	detection_version?: number;
}

export enum DrawableTag {
	MARKER = 'marker',
	LABEL = 'label',
	OFFSET = 'offset',
	LINE = 'line',
	MASK = 'mask',
	VERTICAL_SEPARATION = 'vertical-separation',
}

export type DrawableState =
	| LabelDrawableState
	| BaseMarkerDrawableState
	| LineDrawableState
	| MarkerDrawableState
	| MaskDrawableState
	| VerticalSeparationDrawableState;
export interface BaseDrawableState {
	id: string;
	/** Type of drawable eg "marker" or "line" */
	tag: DrawableTag;
	/** Link the drawable into the collection */
	link?: DrawableLink | DrawableLink[];
}

export interface DrawableLink extends FieldID {
	text?: string;
}

export interface LabelDrawableState extends BaseDrawableState, Point {
	/** Text to show on the label */
	text?: string | string[];
	/** Show the delete button ? **/
	deletable?: boolean;
}

export type MarkerDrawableState = BaseDrawableState &
	Point & {
		label?: LabelDrawableState;
		pair?: string | string[];
		insight?: MarkerInsightState;
	} & (
		| {
				type: MarkerType.NONE;
		  }
		| {
				type: MarkerType.BASE;
				offset: number;
				/**
				 * The base was derived by a tool rather than placed by a user, and must not be moved. Set by the
				 * dedicated MidSpan tool, which computes the base from a paired ground capture (UFO-1082).
				 */
				locked?: boolean;
		  }
		| {
				type: MarkerType.BASE_OFFSET;
		  }
	);

export interface MaskDrawableState extends BaseDrawableState {
	tag: DrawableTag.MASK;
	pukeko_data?: {
		product_version_number?: number;
		resource_path?: string;
	};
}

export interface VerticalSeparationDrawableState extends BaseDrawableState {
	label: LabelDrawableState;
	topMarkerId: string;
	bottomMarkerId: string;
	fieldId: string;
}

export type BaseMarkerDrawableState = MarkerDrawableState & {
	type: MarkerType.BASE;
};

export interface LineDrawableState extends BaseDrawableState {
	/** Starting point of the line */
	start: Point;
	/** End point of the line */
	end: Point;
	label: LabelDrawableState;
}

export interface FieldID {
	/** ID of the sub form to link to. */
	formID: string;
	/** Name of the field to link to. */
	name: string;
	/** Collection Id for the collection */
	collectionID?: string;
}
